import React, { useEffect } from "react";
import { Rect } from "react-konva";
import Konva from "konva";

const BackRect: React.FC<{
  x: number;
  y: number;
  canvasWidth: number;
  canvasHeight: number;
  hue: number;
  val: number;
  isWeekEnd: boolean;
}> = ({ x, y, canvasWidth, canvasHeight, hue, val, isWeekEnd }) => {
  const BRRef: any = React.useRef();
  const width = isWeekEnd === true ? 4.8855 : 1.91;
  const height = isWeekEnd === true ? 2.4 : 7.2;

  useEffect(() => {
    BRRef.current.cache();
    BRRef.current.getLayer().batchDraw();
  }, [hue]);

  useEffect(() => {
    BRRef.current.cache();
    BRRef.current.getLayer().batchDraw();
  }, [canvasWidth]);

  return (
    <>
      <Rect
        x={x}
        y={y}
        width={canvasWidth / width}
        height={canvasHeight / height}
        fill="#816867"
        filters={[Konva.Filters.HSV]}
        value={val}
        hue={hue}
        ref={BRRef}
        opacity={0.5}
      />
    </>
  );
};

export default BackRect;
